export default __webpack_public_path__ + "static/imgOpinionCurV-4586a1a7ac4769cd07e9350064313b04.png";